module.exports = __webpack_public_path__ + "img/icon_shoppguide_index.7568bf28.svg";